// biome-ignore-all lint/style/noMagicNumbers: these are all time constants

export const ONE_SECOND = 1000;
export const THREE_SECONDS = 3 * ONE_SECOND;
export const TEN_SECONDS = 10 * ONE_SECOND;

export const ONE_MINUTE = 60 * ONE_SECOND;
export const FIVE_MINUTES = 5 * ONE_MINUTE;

export const ONE_HOUR = ONE_MINUTE * 60;
export const ONE_DAY = ONE_HOUR * 24;
export const THREE_DAYS = ONE_DAY * 3;

export const MONTHS_IN_YEAR = 12;
